
import { useMediaQuery, type Theme } from "@mui/material";

export const useIsSmall = () => useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));